export enum PhoneNumberType {
  MOBILE = 'MOBILE',
  OFFICE = 'OFFICE',
  PRIVATE = 'PRIVATE'
}
